import { render, staticRenderFns } from "./teamTypeList.vue?vue&type=template&id=6a742b4e&scoped=true&"
import script from "./teamTypeList.vue?vue&type=script&lang=js&"
export * from "./teamTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a742b4e",
  null
  
)

export default component.exports